// validation.js
export const validateForm = (formData) => {
  const errors = {};
  if (!formData.date) {
    errors.date = "date is required";
  } else if (!isValidDate(formData.date)) {
    errors.date = "Invalid start date format";
  }
  return errors;
};

export const isValidDate = (date) => {
  // Basic date validation regex, you can enhance it
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  return dateRegex.test(date);
};
